import { render, staticRenderFns } from "./SysBotao.vue?vue&type=template&id=e903a3d0&scoped=true"
import script from "./SysBotao.vue?vue&type=script&lang=js"
export * from "./SysBotao.vue?vue&type=script&lang=js"
import style0 from "./SysBotao.vue?vue&type=style&index=0&id=e903a3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e903a3d0",
  null
  
)

export default component.exports